
















































import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import * as cg_user_types from "@/store/constants/cg_user_types";
import * as setting_types from "@/store/constants/setting_types";
import Container from "@/components/Container/Container.vue";
import NavBar from "@/components/NavBar/NavBar.vue";
import NavTab from "@/components/NavTab/NavTab.vue";
import Swiper from "@/components/Swiper/Swiper.vue";
import { swiperSlide } from "vue-awesome-swiper";
import Scroller from "@/components/Scroller/Scroller.vue";
import CoinsTitle from "@/components/SkuTitle/CoinsTitle.vue";
import LimitedCoin from "@/components/CoinEntrance/limitCoins/limitCoins.vue";
import RegularCoin from "@/components/CoinEntrance/RegularCoin.vue";
import LuckyCoin from "@/components/CoinEntrance/LuckyCoin.vue";
import VipPackages from "@/components/CoinEntrance/VipPackages.vue";
import StoreTitle from "./StoreTitle/index.vue";
import BackUpAppRecommend from "@/components/BackUpAppRecommend/BackUpAppRecommend.vue";
import HotApp from "@/components/HotApps/HotApps.vue";
import DailyChallenge from "@/components/DailyChallenge/DailyChallenge.vue";
import {
  back_up_can_recommend,
  back_up_show_rewards,
  back_up_icon,
  download_back_up
} from "@/services/super_pay/super_pay_helper";
import SuperPayCache from "@/services/super_pay";
import { isIos } from "@/utils/lodash";
import * as cgConst from "@/api/cg/base/cg_const";
import listenNative from "@/jsbridge/service/listenNative";
@Component({
  components: {
    Container,
    NavBar,
    NavTab,
    Swiper,
    swiperSlide,
    Scroller,
    CoinsTitle,
    LimitedCoin,
    RegularCoin,
    VipPackages,
    StoreTitle,
    LuckyCoin,
    BackUpAppRecommend,
    HotApp,
    DailyChallenge
  }
})
export default class CoinsContainer extends Vue {
  @Getter(setting_types.GETTER_CLIENT_SETTINGS)
  private settingData: any;
  @Getter(cg_user_types.GETTER_COINS)
  private userCoins: any;
  @Action(setting_types.UPDATE_GX_SETTING_DATA)
  private updateCoinStoreSetting: any;
  private activeIndex = 0;

  private showBackUpRecommend: boolean | string = false;

  get backUpReward() {
    return back_up_show_rewards();
  }

  get backUpIcon() {
    return back_up_icon();
  }

  get isIOS() {
    return isIos();
  }

  private tabsArr: object[] = [
    {
      label: "Buy Coins",
      labelColor: "#5C75EC",
      imgUrl: require("@/assets/icons-file/tab/coin_store_title_icon.png")
    },
    {
      label: "Free Coins",
      labelColor: "#17C396",
      imgUrl: require("@/assets/icons-file/tab/free_coins_title_icon.png")
    }
  ];

  private clickRecommend() {
    download_back_up("free_coins", async () => {
      this.showBackUpRecommend = await back_up_can_recommend();
    });
  }

  private goBack() {
    this.$router.go(-1);
  }

  private async created() {
    this.updateCoinStoreSetting(cgConst.TAB_COIN_STORE_KEYS);
    this.activeIndex = (this.$route.query as any).slideIndex
      ? parseInt((this.$route.query as any).slideIndex, 10)
      : 0;
    this.showBackUpRecommend = await back_up_can_recommend();
    if (this.showBackUpRecommend) {
      listenNative.addListen(
        "will_enter_foreground",
        async () => {
          console.log("coinstore will_enter_foreground");
          await SuperPayCache.getOnlineApps();
          this.showBackUpRecommend = await back_up_can_recommend();
        },
        { key: "coins_container" }
      );
    }
  }
}
